/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { openModalWithAjax, openModalWithContent } from '../../utils/modal-helpers';

//= require v4/file_uploads
//= require v4/sidebar_boxes
//= require v4/certificates

window.DocumentSets = {

  _showModal(event) {
    event.preventDefault();
    const url = $(event.currentTarget).attr('href');

    return openModalWithAjax('modalContent', url, {}, {
      success(data) {
        return $(document).on('opened.fndtn.reveal', '[data-reveal]', () => FileUploads.basicInitialize());
      }
    });
  },

  _showModalTiny(event) {
    event.preventDefault();
    const url = $(event.currentTarget).attr('href');

    return openModalWithAjax('modalContentTiny', url, {}, {
      success(data) {
        return $(document).on('opened.fndtn.reveal', '[data-reveal]', () => FileUploads.basicInitialize());
      }
    });
  },

  _showOtherReason() {
    const $reason = $('#reason-div');
    if ($("input[name='document_set[unsubmit_reason]']:checked").val() === 'Other') {
      $reason.removeClass('hide');
      return $reason.find('textarea').attr('disabled', false);
    } else {
      $reason.addClass('hide');
      return $reason.find('textarea').attr('disabled', true);
    }
  },

  _editDocumentLabel(event) {
    event.preventDefault();
    $(event.currentTarget).hide();
    const $form = $('#edit-document-label-form');
    $form.removeClass('hide');
    return $form.find('input').focus();
  },

  _updateDocumentLabel(event, response) {
    this._hideForm();
    if (response.label.length > 0) {
      $('#edit-document-label').text(response.label);
    }
    return this._showLabel();
  },

  _showLabel() {
    const $label = $('#edit-document-label');
    return $label.show();
  },

  _hideForm() {
    const $form = $('#edit-document-label-form');
    return $form.addClass('hide');
  },

  _cancelSave() {
    this._showLabel();
    return this._hideForm();
  },

  _initializeLabel() {
    $(document).on('click', '#edit-document-label', _.bind(this._editDocumentLabel, this));
    $(document).on('click', '#edit-document-label-form #cancel-save-label', _.bind(this._cancelSave, this));
    return $(document).on('ajax:success', '#edit-document-label-form', _.bind(this._updateDocumentLabel, this));
  },

  _showModalWithContent(modal, content, event) {
    event.preventDefault();
    const modalId = modal.replace('#', '');
    return openModalWithContent(modalId, content);
  },

  _updateIssueFormState(event) {
    let newState;
    return newState = $(event.currentTarget).val();
  },

  _showMigrateModal() {
    return $(() => $('#migrate_modal').exists().foundation('reveal', 'open'));
  },

  _showDocumentDescriptionTooltip() {
    return $('[data-powertip]').powerTip();
  },

  initializeIndex(showMigrateModal) {
    if (showMigrateModal == null) { showMigrateModal = false; }
    $(document).on('click', '.add-document-btn, #document-set-history, [id^="edit-doc-"], [id^="history-doc-"], [id^="history-doc-btn-"]', _.bind(this._showModal, this));
    $(document).on('click', '#add-category-btn', _.bind(this._showModalTiny, this));
    $(document).on('click', "input[name='document_set[unsubmit_reason]']", _.bind(this._showOtherReason, this));
    $(document).on('click', ".missing-company-stamp", _.bind(this._showModalWithContent, this, '#modalContent', '#companyStampMissingContent'));
    $(document).on('change', "[id^='select-issue-state-']", _.bind(this._updateIssueFormState, this));
    this._initializeLabel();
    if (showMigrateModal) { this._showMigrateModal(); }
    SidebarBoxes.initialize();
    return this._showDocumentDescriptionTooltip();
  }
};
